import { render, staticRenderFns } from "./RouterViewWithLoader.vue?vue&type=template&id=7fea7b48&scoped=true&"
import script from "./RouterViewWithLoader.vue?vue&type=script&lang=js&"
export * from "./RouterViewWithLoader.vue?vue&type=script&lang=js&"
import style0 from "./RouterViewWithLoader.vue?vue&type=style&index=0&id=7fea7b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fea7b48",
  null
  
)

export default component.exports